// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"

const modelClassData = {
  "attributes": {
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "resource_id": {
      "column": {
        "default": null,
        "name": "resource_id",
        "null": false,
        "type": "string"
      },
      "name": "resource_id",
      "selected_by_default": null,
      "translated": null
    },
    "resource_type": {
      "column": {
        "default": null,
        "name": "resource_type",
        "null": false,
        "type": "string"
      },
      "name": "resource_type",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "WorkerPlugins::WorkplaceLink",
  "collectionKey": "worker_plugins/workplace_links",
  "collectionName": "workplace_links",
  "i18nKey": "worker_plugins/workplace_link",
  "camelizedLower": "workerPlugins::WorkplaceLink",
  "name": "WorkplaceLink",
  "nameDasherized": "workplace-link",
  "pluralName": "worker_plugins_workplace_links",
  "ransackable_associations": [
    {
      "className": "Workplace",
      "collectionName": "workplaces",
      "foreignKey": "workplace_id",
      "name": "workplace",
      "macro": "belongs_to",
      "resource_name": "Workplace",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "resource_type",
      "column": {
        "default": null,
        "name": "resource_type",
        "null": false,
        "type": "string"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [],
  "paramKey": "workplace_link",
  "primaryKey": "id"
}

/** Frontend model for WorkplaceLink. */
export default class WorkplaceLink extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  resourceId() {
    return this.readAttributeUnderscore("resource_id")
  }

  /** @returns {boolean} */
  hasResourceId() {
    const value = this.resourceId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  resourceType() {
    return this.readAttributeUnderscore("resource_type")
  }

  /** @returns {boolean} */
  hasResourceType() {
    const value = this.resourceType()

    return this._isPresent(value)
  }
}
